<template>
  <div
    :class="{
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
      _boxBg_strong_secondLevel: styleType == 'typeStrong',
    }"
    class="absolute_center list_overview"
    :style="'width: ' + realWidth"
  >
    <div class="selfClose_btn" style="top: 10px" @click="close"></div>
    <div class="boxTitle">运输车辆清单总览</div>
    <div class="_innerBox">
      <div class="_carinfo_tab">
        <div
          class="tab_item tab_left"
          :class="[curTab == 'carTimes' ? 'tab_active' : '']"
          @click="tabSwitch('carTimes')"
        >
          进出厂车次信息
        </div>
        <div
          class="tab_item"
          :class="[curTab == 'carInfo' ? 'tab_active' : '']"
          @click="tabSwitch('carInfo')"
        >
          进出厂车辆信息
        </div>
      </div>
      <div class="tab1" v-show="curTab == 'carTimes'">
        <div class="check_box">
          <el-form
            :inline="true"
            class="demo-form-inline secondLevel-form-inline"
          >
            <el-form-item label="进出厂时段：" class="secondLevel-label">
              <!--              <el-date-picker
                v-model="timeArr"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 455px"
              >
                &lt;!&ndash; value-format="yyyy-MM-dd HH:mm"  &ndash;&gt;
              </el-date-picker>-->
              <DatePicker
                :init-width="'420px'"
                :currentDateList="timeArr"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :needInitTime="false"
                :topPx="'50px'"
                :idIndex="3"
                @dateChange="changeTime"
              ></DatePicker>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="车牌号：">
              <el-input
                class="secondLevel-input"
                v-model="params.numberPlate"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="secondLevel-label"
              label="车辆使用类型："
              v-if="isPublicCleanTransport || customerId == 89"
            >
              <el-select
                class="secondLevel-select"
                v-model="params.vehicleUseType"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option
                  v-for="(item, index) in vehicleUseTypeArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="secondLevel-label"
              :label="customerId == 54 ? '车辆使用类型：' : '车辆类型：'"
              v-else
            >
              <el-select
                class="secondLevel-select"
                v-model="params.vehicleUseType"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option
                  v-for="(item, index) in vehicleUseTypeArr"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="燃料类型：">
              <el-select
                class="secondLevel-select"
                v-model="params.fuelType"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option
                  v-for="(item, index) in fuelTypeListArr"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="排放阶段：">
              <el-select
                class="secondLevel-select"
                v-model="params.vehicleEmission"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <template
                  v-if="emissionTypeListArr && emissionTypeListArr.length"
                >
                  <el-option
                    v-for="(item, index) in emissionTypeListArr"
                    :key="index"
                    :label="item.name"
                    :value="item.emissionCode"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="车牌颜色：">
              <el-select
                class="secondLevel-select"
                v-model="params.plateColor"
                placeholder="请选择"
              >
                <!-- <el-option label="全部" value=""></el-option>
                <el-option v-for="(item, index) in plateColorListArr" :key="index" :label="item" :value="item"></el-option>-->
                <el-option label="全部" value></el-option>
                <el-option label="蓝牌" :value="1"></el-option>
                <el-option label="黄牌" :value="2"></el-option>
                <el-option label="白牌" :value="3"></el-option>
                <el-option label="黑牌" :value="4"></el-option>
                <el-option label="绿牌" :value="5"></el-option>
                <el-option label="黄绿牌" :value="6"></el-option>
                <el-option label="未知" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="secondLevel-label"
              label="进厂门岗："
              v-if="isPublicCleanTransport"
            >
              <el-select
                class="secondLevel-select"
                v-model="params.inGatePostName"
                v-if="customerId == 19"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option
                  v-for="(item, index) in postCodeListArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-select
                class="secondLevel-select"
                v-model="params.inGatePostCode"
                v-else
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option
                  v-for="(item, index) in postCodeListArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="进厂门岗：" v-else>
              <el-select
                class="secondLevel-select"
                v-model="params.inGatePostCode"
                placeholder="请选择"
              >
                <el-option label="全部门岗" value="全部门岗"></el-option>
                <el-option
                  v-for="(item, index) in postCodeListArr"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="称重单号：">
              <el-input
                class="secondLevel-input"
                v-model="params.transportCode"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="货物种类：">
              <el-input
                class="secondLevel-input"
                v-model="params.transportType"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="货物名称：">
              <el-input
                class="secondLevel-input"
                v-model="params.transportName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="secondLevel-label"
              label="出厂门岗："
              v-if="isPublicCleanTransport"
            >
              <el-select
                class="secondLevel-select"
                v-model="params.outGatePostCode"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option
                  v-for="(item, index) in postCodeListArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="出厂门岗：" v-else>
              <el-select
                class="secondLevel-select"
                v-model="params.outGatePostCode"
                placeholder="请选择"
              >
                <el-option label="全部门岗" value="全部门岗"></el-option>
                <el-option
                  v-for="(item, index) in postCodeListArr"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="VIN：">
              <el-input
                class="secondLevel-input"
                v-model="params.vin"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="发动机号码：">
              <el-input
                class="secondLevel-input"
                v-model="params.engineNumber"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item  class="secondLevel-label" label="联网状态：">
              <el-select class="secondLevel-select" v-model="params.onlineStatus">
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in netstatusListArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="注册日期：">
              <!-- <el-date-picker v-model="params.registrationDate"  type="datetime" style="width: 355px">
              </el-date-picker>-->
              <!-- <el-date-picker
                v-model="timeArr2"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 455px"
              >-->
              <!-- value-format="yyyy-MM-dd HH:mm"  -->
              <!-- </el-date-picker> -->
              <DatePicker
                :init-width="'420px'"
                :currentDateList="timeArr2"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :needInitTime="false"
                :topPx="'50px'"
                :idIndex="4"
                @dateChange="changeTime1"
              ></DatePicker>
            </el-form-item>
            <el-form-item class="secondLevel-label">
              <a class="self_btn" @click="seartchList()">查询</a>
              <a class="self_btn" @click="reset()">重置</a>
              <a class="self_btn" @click="exportExcel()">导出</a>
              <!--              <a
                class="self_btn"
                @click="addCarInfo()"
                v-if="showCleanTransportSetVal"
                >添加</a
              >-->
              <!-- <a class="self_btn" @click="addNewCarInfo('')">添加车辆</a>
              <a class="self_btn" @click="addNewCarInfo('xxxx')">编辑车辆</a>-->
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" :style="'height: ' + realHeight">
          <el-table
            :data="dataList"
            style="width: 100%"
            :header-cell-class-name="'thClass'"
            :header-row-class-name="'headTrClass'"
            :cell-class-name="'tdClass'"
            :row-class-name="'trClass'"
            class="secondLevel_table"
          >
            <el-table-column type="index" label="序号" :width="70">
              <template #default="scope">
                {{ scope.$index + 1 + (params.pageNo - 1) * params.pageSize }}
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              v-for="(item, key) in lableAll"
              :key="key"
              :sortable="
                item.key == 'inTime' ||
                item.key == 'inMeasureTime' ||
                item.key == 'outMeasureTime' ||
                item.key == 'outTime'
                  ? true
                  : false
              "
              :width="
                item.key == 'numberPlate'||
                item.key == 'inTransportCode' ||
                item.key == 'inTransportVolume' ||
                item.key == 'inTransportType' ||
                item.key == 'inTransportName' ||
                item.key == 'outTransportCode' ||
                item.key == 'outMeasureTime' ||
                item.key == 'outTransportVolume' ||
                item.key == 'outTransportName' ||
                item.key == 'outTransportType' ||
                item.key == 'inTime' ||
                item.key == 'outTime' ||
                item.key == 'loadDischargeAddress' ||
                item.key == 'engineNumber' ||
                item.key == 'inGatePostName' ||
                item.key == 'outTransportVolume'
                  ? 155
                  : item.key == 'inMeasureTime' ||
                    item.key == 'outMeasureTime' ||
                    item.key == 'vehicleUseType'
                  ? 185
                  : item.key == 'gateNumber' || item.key == 'natureUse' ||
                  item.key == 'inOutNumber'
                  ? 110
                  : ''
              "
              :prop="item.key"
              :label="item.label"
            >
              <template #default="scope">
                <!-- <span v-if="item.key == 'vehicleEmission'">{{vehicleMissionsName[scope.row[item.key]]}}</span> -->
                <div
                  v-if="
                    (item.key == 'inTime' ||
                      item.key == 'outTime' ||
                      item.key == 'inMeasureTime' ||
                      item.key == 'outMeasureTime') &&
                    scope.row[item.key]
                  "
                >
                  <span>{{ scope.row[item.key].split(" ")[0] }}</span>
                  <br />
                  <span>{{ scope.row[item.key].split(" ")[1] }}</span>
                </div>
                <div v-else-if="item.key == 'onlineStatus'">
                  <span>{{
                    scope.row[item.key] == 1 ? "已联网" : scope.row[item.key] == 0 ? "未联网" : scope.row[item.key] == '/' ? "/" : "未知"
                  }}</span>
                </div>
                <span v-else>{{ scope.row[item.key] }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="numberPlate" label="环保登记编码/内部管理号牌" align="center"></el-table-column>
            <el-table-column prop="registrationDate" label="注册日期" align="center"></el-table-column>
            <el-table-column prop="vin" label="车辆识别代号(VIN)" align="center"></el-table-column>
            <el-table-column prop="engineNumber" label="发动机号码" align="center"></el-table-column>
            <el-table-column prop="vehicleEmissions" label="排放阶段" align="center">
              <template #default="scope">{{vehicleMissionsName[scope.row.vehicleEmissions]}}</template>
            </el-table-column>-->
            <el-table-column label="详情" align="center">
              <template #default="scope">
                <span
                  class="view"
                  style="cursor: pointer; color: rgb(0, 252, 255)"
                  @click="rowClick0(scope.row)"
                  >查看</span
                >
                <!-- <span v-if="showCleanTransportSetVal" style="cursor: pointer; color: rgb(0, 252, 255)">|</span>
                <span
                  class="view"
                  style="cursor: pointer; color: rgb(0, 252, 255)"
                  @click.stop="editInfo(scope.row)"
                  v-if="showCleanTransportSetVal"
                >编辑</span>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <div class="page_left">
            <div class="tips">根据筛选条件统计进出厂车辆运输数据</div>
            <div class="static-data">
              <span>
                进厂车次总数：{{ statisticsInfo && statisticsInfo.inTotal }}
              </span>
              <span>
                出厂车次总数：{{ statisticsInfo && statisticsInfo.outTotal }}
              </span>
              <span>
                进厂运输总量：{{
                  statisticsInfo && statisticsInfo.inTransportTotal
                }}t
              </span>
              <span>
                出厂运输总量：{{
                  statisticsInfo && statisticsInfo.outTransportTotal
                }}t
              </span>
            </div>
          </div>
          <div class="page-wrap">
            <el-pagination
              @current-change="handleCurrentChange0"
              :current-page="params.pageNo"
              :page-size="params.pageSize"
              layout="total,prev, pager, next, jumper"
              :total="page_total"
            ></el-pagination>
            <p>跳转</p>
          </div>
        </div>
      </div>
      <div class="tab2" v-show="curTab == 'carInfo'">
        <div class="check_box">
          <el-form
            :inline="true"
            class="demo-form-inline secondLevel-form-inline"
          >
            <el-form-item label="进出厂时段：" class="secondLevel-label">
              <!--              <el-date-picker
                v-model="timeArr1"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 455px"
              >
              </el-date-picker>-->
              <DatePicker
                :init-width="'450px'"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="timeArr1"
                :needInitTime="false"
                topPx="50px"
                :leftPx="'0px'"
                @dateChange="getNewTime"
                :idIndex="5"
              ></DatePicker>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="车牌号：">
              <el-input
                class="secondLevel-input"
                v-model="params1.numberPlate"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="排放阶段：">
              <el-select
                class="secondLevel-select"
                v-model="params1.vehicleEmission"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <template
                  v-if="emissionTypeListArr && emissionTypeListArr.length"
                >
                  <el-option
                    v-for="(item, index) in emissionTypeListArr"
                    :key="index"
                    :label="item.name"
                    :value="item.emissionCode"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="车牌颜色：">
              <el-select
                class="secondLevel-select"
                v-model="params1.vehicleColor"
                placeholder="请选择"
              >
                <el-option label="全部" value></el-option>
                <el-option label="蓝牌" :value="1"></el-option>
                <el-option label="黄牌" :value="2"></el-option>
                <el-option label="白牌" :value="3"></el-option>
                <el-option label="黑牌" :value="4"></el-option>
                <el-option label="绿牌" :value="5"></el-option>
                <el-option label="黄绿牌" :value="6"></el-option>
                <el-option label="未知" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label">
              <a class="self_btn" @click="handleCurrentChange(1)">查询</a>
              <a class="self_btn" @click="reset1()">重置</a>
              <a class="self_btn" @click="exportExcel1()">导出</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="tabel_list">
          <div class="tab_left">
            <div class="tab_title">进厂车辆信息</div>
            <div class="table_box" style="height: 540px">
              <el-table
                :data="dataList1"
                style="width: 1446px"
                @row-click="rowClick"
                :header-cell-class-name="'thClass'"
                :header-row-class-name="'headTrClass'"
                :cell-class-name="'tdClass'"
                :row-class-name="'trClass'"
                class="secondLevel_table"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  :width="100"
                ></el-table-column>
                <el-table-column
                  v-for="(item, key) in lableAll1"
                  :key="key"
                  :prop="item.key"
                  :label="item.label"
                ></el-table-column>
                <el-table-column label="详情" align="center">
                  <template #default="scope">
                    <span
                      class="view"
                      style="cursor: pointer; color: rgb(0, 252, 255)"
                      @click="
                        getCarDetail(
                          scope.row.numberPlate,
                          scope.row.vehicleColor
                        )
                      "
                      >查看</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page_box">
              <div class="page_left">
                <div class="static-data">
                  <span>进厂车辆总数：{{ page_total1 }}</span>
                </div>
              </div>
              <div class="page-wrap">
                <el-pagination
                  @current-change="handleCurrentChange1"
                  :current-page="pageNo1"
                  :page-size="pageSize1"
                  layout="total,prev, pager, next, jumper"
                  :total="page_total1"
                ></el-pagination>
                <p>跳转</p>
              </div>
            </div>
          </div>
          <div class="tab_right">
            <div class="tab_title">出厂车辆信息</div>
            <div class="table_box" style="height: 540px">
              <el-table
                :data="dataList2"
                style="width: 1446px"
                @row-click="rowClick"
                :header-cell-class-name="'thClass'"
                :header-row-class-name="'headTrClass'"
                :cell-class-name="'tdClass'"
                :row-class-name="'trClass'"
                class="secondLevel_table"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  :width="100"
                ></el-table-column>
                <el-table-column
                  v-for="(item, key) in lableAll1"
                  :key="key"
                  :prop="item.key"
                  :label="item.label"
                ></el-table-column>
                <el-table-column label="详情" align="center">
                  <template #default="scope">
                    <span
                      class="view"
                      style="cursor: pointer; color: rgb(0, 252, 255)"
                      @click="getCarDetail(scope.row.numberPlate)"
                      >查看</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page_box">
              <div class="page_left">
                <div class="static-data">
                  <span>出厂车辆总数：{{ page_total2 }}</span>
                </div>
              </div>
              <div class="page-wrap">
                <el-pagination
                  @current-change="handleCurrentChange2"
                  :current-page="pageNo2"
                  :page-size="pageSize2"
                  layout="total,prev, pager, next, jumper"
                  :total="page_total2"
                ></el-pagination>
                <p>跳转</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="list_overview_detail"
      style="width: 1600px"
      v-if="detailShow == 1"
      :class="{ 'background-strong': styleType == 'typeStrong' }"
    >
      <div class="inout_detail_top">
        <div class="detail_title">
          {{ newAccessType ? "运输车辆信息" : "车辆运输信息" }}
        </div>
        <div class="selfClose_btn" @click="returnClick(1)"></div>
      </div>
      <!-- <div class="selfClose_btn" style="top:10px" @click="returnClick(1)"></div>
      <div class="detail_title">车辆运输信息</div>-->
      <div class="account">
        <div class="account-title">车辆基础信息</div>
        <div class="basic-info">
          <div class="basic-item">
            <label class="item-label">车牌号码：</label>
            <span>{{ info && info.numberPlate }}</span>
          </div>
          <div class="basic-item car-type-content">
            <label class="item-label">车辆类型：</label>
            <span class="car-type-value">{{ info && info.vehicleType }}</span>
          </div>

          <div class="basic-item">
            <label class="item-label">燃料类型：</label>
            <span>{{ info && info.fuelType }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">排放阶段：</label>
            <span>{{ info.vehicleEmissionsName }}</span>
          </div>
          <div class="basic-item" v-if="addThreeItem">
            <label class="item-label">车辆使用性质：</label>
            <span>{{ info.natureUse }}</span>
          </div>
             <div class="basic-item" v-if="addThreeItem">
            <label class="item-label">联网状态：</label>
            <span> {{info && (info.onlineStatus == "0" ? "未联网" : info.onlineStatus == "1" ? "已联网" : "未知")}}</span>
          </div>
          <div class="basic-item" v-if="addThreeItem">
            <label class="item-label">品牌型号：</label>
            <span>{{ info && info.model }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">车辆识别代号(VIN)：</label>
            <span>{{ info && info.vin }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">发动机号码：</label>
            <span>{{ info && info.engineNumber }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">注册日期：</label>
            <span>{{ info && info.registrationDate }}</span>
          </div>
          <div class="basic-item" v-if="newAccessType">
            <label class="item-label">所有人：</label>
            <span>{{ info && info.owner }}</span>
          </div>
        </div>
        <div class="account-title">车辆图片</div>
        <div class="picture-info">
          <div
            class="picture-inner"
            @click="picture_click(info.drivingLicenseImage)"
          >
            <div class="picture">
              <img
                v-if="info.drivingLicenseImage"
                :src="info && info.drivingLicenseImage"
              />
              <img v-else src="./img/no_img.png" />
              <span>行驶证</span>
            </div>
          </div>
          <div class="picture-inner" @click="picture_click(info.onBoardList)">
            <div class="picture">
              <img v-if="info.onBoardList" :src="info && info.onBoardList" />
              <img v-else src="./img/no_img.png" />
              <span>随车清单</span>
            </div>
          </div>
          <div
            class="picture-inner"
            v-if="newAccessType && customerId != 50"
            @click="picture_click(info.vehicleHeadImg)"
          >
            <div class="picture">
              <img
                v-if="info.vehicleHeadImg"
                :src="info && info.vehicleHeadImg"
              />
              <img v-else src="./img/no_img.png" />
              <span>车头正面</span>
            </div>
          </div>
          <div
            class="picture-inner"
            v-if="newAccessType && customerId != 50"
            @click="picture_click(info.vehicleNameplate)"
          >
            <div class="picture">
              <img
                v-if="info.vehicleNameplate"
                :src="info && info.vehicleNameplate"
              />
              <img v-else src="./img/no_img.png" />
              <span>车身铭牌</span>
            </div>
          </div>
          <div
            class="picture-inner"
            v-if="newAccessType && customerId != 50"
            @click="picture_click(info.vinVerificationImg)"
          >
            <div class="picture">
              <img
                v-if="info.vinVerificationImg"
                :src="info && info.vinVerificationImg"
              />
              <img v-else src="./img/no_img.png" />
              <span>机动车环保网查询图片</span>
            </div>
          </div>
          <div
            class="picture-inner"
            v-if="newAccessType && customerId != 50"
            @click="picture_click(info.vehicleLicenseVerificationImg)"
          >
            <div class="picture">
              <img
                v-if="info.vehicleLicenseVerificationImg"
                :src="info && info.vehicleLicenseVerificationImg"
              />
              <img v-else src="./img/no_img.png" />
              <span>重型柴油车排放阶段查询图片</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="list_overview_detail more-detail"
      style="width: 1600px"
      v-if="detailShow == 2"
      :class="{ 'background-strong': styleType == 'typeStrong' }"
    >
      <div class="inout_detail_top">
        <div class="detail_title">
          {{ newAccessType ? "车辆运输信息" : "运输车辆信息" }}
        </div>
        <div class="selfClose_btn" @click="returnClick(2)"></div>
      </div>
      <!-- <div class="selfClose_btn" style="top:10px" @click="returnClick(2)"></div>
      <div class="detail_title">车辆运输信息</div>-->
      <div class="account" style="height: auto">
        <div class="account-title">车辆基础信息</div>
        <div class="basic-info">
          <div class="basic-item">
            <div class="item-label">车牌号码：</div>
            <div class="item-line">{{ carinfo && carinfo.numberPlate }}</div>
          </div>
          <div class="basic-item" v-if="!isPublicCleanTransport">
            <div class="item-label" v-if="customerId == 89">车辆使用类型：</div>
            <div class="item-label" v-else>车辆类型：</div>
            <div class="item-line">
              {{
                carinfo && customerId == 89
                  ? carinfo.vehicleUseType
                  : carinfo.vehicleType
              }}
            </div>
          </div>
          <div class="basic-item" v-if="isPublicCleanTransport">
            <div class="item-label">车辆类型：</div>
            <div class="item-line">{{ carinfo && carinfo.vehicleType }}</div>
          </div>
          <div class="basic-item" v-if="isPublicCleanTransport">
            <div class="item-label">车辆使用类型：</div>
            <div class="item-line">{{ carinfo && carinfo.vehicleUseType }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">燃料类型：</div>
            <div class="item-line">{{ carinfo && carinfo.fuelType }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">排放阶段：</div>
            <div class="item-line">
              {{ vehicleMissionsName[carinfo && carinfo.vehicleEmission] }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">车牌颜色：</div>
            <div class="item-line">{{ carinfo && carinfo.plateColor }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">发动机号码：</div>
            <div class="item-line">{{ carinfo && carinfo.engineNumber }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">车辆识别代号(VIN)：</div>
            <div class="item-line">{{ carinfo && carinfo.vin }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">注册日期：</div>
            <div class="item-line">
              {{ carinfo && carinfo.registrationDate }}
            </div>
          </div>
          <div class="basic-item" v-if="newAccessType">
            <div class="item-label">所有人：</div>
            <div class="item-line">{{ carinfo && carinfo.owner }}</div>
          </div>
          <div class="basic-item" >
            <div class="item-label">联网状态：</div>
            <div class="item-line">
              {{
                carinfo && (carinfo.onlineStatus == "0" ? "未联网" : carinfo.onlineStatus == "1" ? "已联网" : "未知")
              }}
            </div>
          </div>
          <div class="basic-item" >
            <div class="item-label">车辆品牌：</div>
            <div class="item-line">
              {{
                carinfo && carinfo.model
              }}
            </div>
          </div>
          <div class="basic-item" >
            <div class="item-label">使用性质：</div>
            <div class="item-line">
              {{
                carinfo && carinfo.natureUse
              }}
            </div>
          </div>
          <div class="basic-item" v-if="customerId == 50">
            <div class="item-label">核定载重质量：</div>
            <div class="item-line">
              {{ carinfo && carinfo.approvedLoadMass }}
            </div>
          </div>
          <div class="basic-item" v-if="customerId == 50">
            <div class="item-label">最新年检日期：</div>
            <div class="item-line">
              {{ carinfo && carinfo.latestInspectionDate }}
            </div>
          </div>
        </div>
        <div class="account-title">进厂信息</div>
        <div class="basic-info">
          <div class="basic-item">
            <div class="item-label">进厂时间：</div>
            <div class="item-line">{{ carinfo && carinfo.inTime }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂门岗：</div>
            <div class="item-line">
              {{
                carinfo &&
                (isPublicCleanTransport
                  ? carinfo.inGatePostName
                  : carinfo.inGatePostCode)
              }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂称重单号：</div>
            <div class="item-line">
              {{ carinfo && carinfo.inTransportCode }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂货物种类：</div>
            <div class="item-line">
              {{ carinfo && carinfo.inTransportType }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂货物名称：</div>
            <div class="item-line">
              {{ carinfo && carinfo.inTransportName }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂运输量（t）：</div>
            <div class="item-line">
              {{ carinfo && carinfo.inTransportVolume }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂计量时间：</div>
            <div class="item-line">{{ carinfo && carinfo.inMeasureTime }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂门岗编号：</div>
            <div class="item-line">{{ carinfo && carinfo.inNumber }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">进厂道闸：</div>
            <div class="item-line">{{ carinfo && carinfo.inGateNumber }}</div>
          </div>
        </div>
        <div class="account-title">出厂信息</div>
        <div class="basic-info">
          <div class="basic-item">
            <div class="item-label">出厂时间：</div>
            <div class="item-line">{{ carinfo && carinfo.outTime }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">出厂门岗：</div>
            <div class="item-line">
              {{
                carinfo &&
                (isPublicCleanTransport
                  ? carinfo.outGatePostName
                  : carinfo.outGatePostCode)
              }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">出厂称重单号：</div>
            <div class="item-line">
              {{ carinfo && carinfo.outTransportCode }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">出厂货物种类：</div>
            <div class="item-line">
              {{ carinfo && carinfo.outTransportType }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">出厂货物名称：</div>
            <div class="item-line">
              {{ carinfo && carinfo.outTransportName }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">出厂运输量（t）：</div>
            <div class="item-line">
              {{ carinfo && carinfo.outTransportVolume }}
            </div>
          </div>
          <div class="basic-item">
            <div class="item-label">出厂计量时间：</div>
            <div class="item-line">{{ carinfo && carinfo.outMeasureTime }}</div>
          </div>
        </div>
        <div class="account-title">其他信息</div>
        <div class="basic-info">
          <div class="basic-item">
            <div class="item-label">发货单位：</div>
            <div class="item-line">{{ carinfo && carinfo.shipper }}</div>
          </div>
          <div class="basic-item">
            <div class="item-label">收货单位：</div>
            <div class="item-line">{{ carinfo && carinfo.consignee }}</div>
          </div>
          <template v-if="!isPublicCleanTransport">
            <div class="basic-item">
              <div class="item-label">装卸货地点：</div>
              <div class="item-line">
                {{ carinfo && carinfo.loadDischargeAddress }}
              </div>
            </div>
            <div class="basic-item">
              <div class="item-label">记录形式：</div>
              <div class="item-line">{{ carinfo && carinfo.recordMode }}</div>
            </div>
          </template>
          <template v-if="isPublicCleanTransport">
            <div class="basic-item">
              <div class="item-label">进厂装卸货地点：</div>
              <div class="item-line">{{ carinfo && carinfo.inAddress }}</div>
            </div>
            <div class="basic-item">
              <div class="item-label">出厂装卸货地点：</div>
              <div class="item-line">{{ carinfo && carinfo.outAddress }}</div>
            </div>
            <div class="basic-item">
              <div class="item-label">出厂门岗编号：</div>
              <div class="item-line">{{ carinfo && carinfo.outNumber }}</div>
            </div>
            <div class="basic-item">
              <div class="item-label">出厂道闸：</div>
              <div class="item-line">{{ carinfo && carinfo.outGateNumber }}</div>
            </div>
          </template>
        </div>
        <div class="account-title">车辆图片</div>
        <div class="picture-info2">
          <!-- <el-carousel :interval="4000" type="card" height="200px">
              <el-carousel-item v-for="item in 6" :key="item">
                <div class="picture-inner" @click="picture_click(info.drivingLicense)">
                  <div class="picture">
                    <img :src="carinfo&&carinfo.drivingLicense" />
                    <span>name</span>
                  </div>
                </div>
              </el-carousel-item>
          </el-carousel>-->
          <div class="picture-info">
            <div v-if="customerId !=154 && customerId !=152 && customerId != 133" class="picture-inner" @click="picture_click(carinfo.inImage)">
              <div class="picture">
                <img v-if="carinfo.inImage" :src="carinfo && carinfo.inImage" />
                <img v-else src="./img/no_img.png" />
                <span>进厂图片</span>
              </div>
            </div>
            <div v-else class="picture-inner" @click="picture_click(carinfo.inImage)">
              <div class="picture">
                <img v-if="carinfo.inImage" :src="carinfo && carinfo.inImage" />
                <img v-else src="./img/no_img.png" />
                <span>进厂图片1</span>
              </div>
            </div>
            <div v-if="customerId ==154 || customerId ==152 || customerId == 133" class="picture-inner" @click="picture_click(carinfo.inPlateImage)">
              <div class="picture">
                <img v-if="carinfo.inPlateImage" :src="carinfo && carinfo.inPlateImage" />
                <img v-else src="./img/no_img.png" />
                <span>进厂图片2</span>
              </div>
            </div>
            <div v-if="customerId !=154 && customerId !=152 && customerId != 133" class="picture-inner" @click="picture_click(carinfo.outImage)">
              <div class="picture">
                <img
                  v-if="carinfo.outImage"
                  :src="carinfo && carinfo.outImage"
                />
                <img v-else src="./img/no_img.png" />
                <span>出厂图片</span>
              </div>
            </div>
            <div v-else class="picture-inner" @click="picture_click(carinfo.outImage)">
              <div class="picture">
                <img
                  v-if="carinfo.outImage"
                  :src="carinfo && carinfo.outImage"
                />
                <img v-else src="./img/no_img.png" />
                <span>出厂图片1</span>
              </div>
            </div>
            <div v-if="customerId ==154 || customerId == 152 || customerId == 133" class="picture-inner" @click="picture_click(carinfo.outPlateImage)">
              <div class="picture">
                <img
                  v-if="carinfo.outPlateImage"
                  :src="carinfo && carinfo.outPlateImage"
                />
                <img v-else src="./img/no_img.png" />
                <span>出厂图片2</span>
              </div>
            </div>
            <div
              class="picture-inner"
              @click="picture_click(carinfo.driverLicenseImageUrl)"
            >
              <div class="picture">
                <img
                  v-if="carinfo.driverLicenseImageUrl"
                  :src="carinfo && carinfo.driverLicenseImageUrl"
                />
                <img v-else src="./img/no_img.png" />
                <span>行驶证</span>
              </div>
            </div>
            <div
              class="picture-inner"
              @click="picture_click(carinfo.onBoardListImageUrl)"
            >
              <div class="picture">
                <img
                  v-if="carinfo.onBoardListImageUrl"
                  :src="carinfo && carinfo.onBoardListImageUrl"
                />
                <img v-else src="./img/no_img.png" />
                <span>随车清单</span>
              </div>
            </div>
            <div
              class="picture-inner"
              v-if="newAccessType && customerId != 50"
              @click="picture_click(carinfo.vehicleHeadImg)"
            >
              <div class="picture">
                <img
                  v-if="carinfo.vehicleHeadImg"
                  :src="carinfo && carinfo.vehicleHeadImg"
                />
                <img v-else src="./img/no_img.png" />
                <span>车头正面</span>
              </div>
            </div>
            <div
              class="picture-inner"
               v-if="customerId != 50 && customerId != 133"
              @click="picture_click(carinfo.vehicleNameplate)"
            >
              <div class="picture">
                <img
                  v-if="carinfo.vehicleNameplate"
                  :src="carinfo && carinfo.vehicleNameplate"
                />
                <img v-else src="./img/no_img.png" />
                <span>车身铭牌</span>
              </div>
            </div>
            <div
              class="picture-inner"
              v-if="newAccessType && customerId != 50"
              @click="picture_click(carinfo.vinVerificationImg)"
            >
              <div class="picture">
                <img
                  v-if="carinfo.vinVerificationImg"
                  :src="carinfo && carinfo.vinVerificationImg"
                />
                <img v-else src="./img/no_img.png" />
                <span>机动车环保网查询图片</span>
              </div>
            </div>
            <div
              class="picture-inner"
              v-if="newAccessType && customerId != 50"
              @click="picture_click(carinfo.vehicleLicenseVerificationImg)"
            >
              <div class="picture">
                <img
                  v-if="carinfo.vehicleLicenseVerificationImg"
                  :src="carinfo && carinfo.vehicleLicenseVerificationImg"
                />
                <img v-else src="./img/no_img.png" />
                <span>重型柴油车排放阶段查询图片</span>
              </div>
            </div>
             <div
              class="picture-inner"
              v-if="customerId === 133"
              @click="picture_click(carinfo.vehicleLicenseVerificationImg)"
            >
              <div class="picture">
                <img
                  v-if="carinfo.vehicleLicenseVerificationImg"
                  :src="carinfo && carinfo.vehicleLicenseVerificationImg"
                />
                <img v-else src="./img/no_img.png" />
                <span>重型柴油车排放阶段查询图片</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="list_overview_detail add_cartransform_info"
      style="width: 1600px"
      v-if="detailShow == 3"
      :class="{ 'background-strong': styleType == 'typeStrong' }"
    >
      <div class="inout_detail_top">
        <div class="detail_title">
          {{ editStatus == true ? "编辑车辆运输信息" : "新增车辆运输信息" }}
        </div>
        <div class="selfClose_btn" @click="returnClick(2)"></div>
      </div>
      <!-- <div class="selfClose_btn" style="top:10px" @click="returnClick(2)"></div>
      <div class="detail_title">车辆运输信息</div>-->
      <div class="account" style="height: auto">
        <div class="basic-info basic-info-new" v-if="!editStatus">
          <div class="basic-item">
            <label class="item-label">车牌号码：</label>
            <el-input
              class="secondLevel-input"
              v-model="numberPlate"
              placeholder="请输入"
            ></el-input>
          </div>
          <a class="self_btn" @click="getCarDefaultInfo()">查询</a>
          <a
            class="self_btn"
            style="width: 180px"
            @click="addNewCarInfo()"
            v-if="!carDefaultInfo"
            >新增车辆信息</a
          >
          <a
            class="self_btn"
            style="width: 180px"
            @click="addNewCarInfo(numberPlate)"
            v-if="carDefaultInfo"
            >编辑车辆信息</a
          >
        </div>
        <div class="account-title">车辆基础信息</div>
        <div class="basic-info">
          <div class="basic-item">
            <label class="item-label">录入门岗SN：</label>
            <!-- <span>{{carDefaultInfo&&carDefaultInfo.gatePostCode}}</span> -->
            <el-select
              class="secondLevel-select"
              v-model="carDefaultInfo.gatePostCode"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in postCodeListArr"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="basic-item">
            <label class="item-label">车牌号码：</label>
            <!-- <el-input
              class="secondLevel-input"
              v-model="carDefaultInfo.numberPlate"
              placeholder="请输入"
            ></el-input>-->
            <span>{{ carDefaultInfo && carDefaultInfo.numberPlate }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">车辆识别代号(VIN)：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.vin }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">注册日期：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.registrationDate }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">发证日期：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.issueDate }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">使用性质：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.natureUse }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">所有人：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.owner }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">发动机号码：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.engineNumber }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">排放阶段：</label>
            <span>
              {{
                vehicleMissionsName[
                  carDefaultInfo && carDefaultInfo.vehicleEmissions
                ]
              }}
            </span>
          </div>
          <div class="basic-item">
            <label class="item-label">车辆类型：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.vehicleType }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">品牌型号：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.model }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">住址：</label>
            <span>{{ carDefaultInfo && carDefaultInfo.address }}</span>
          </div>
        </div>
        <div class="basic-info">
          <div class="basic-item">
            <label class="item-label">进出厂：</label>
            <el-select
              class="secondLevel-select"
              v-model="addCarTimesInfoParams.inOrOut"
              @change="changeInOrOut"
              placeholder="请选择"
            >
              <el-option label="进厂" :value="1"></el-option>
              <el-option label="出厂" :value="2"></el-option>
            </el-select>
          </div>
          <div class="basic-item">
            <label class="item-label">进出厂车牌号：</label>
            <el-input
              class="secondLevel-input"
              v-model="addCarTimesInfoParams.numberPlate"
              placeholder="请输入"
            ></el-input>
          </div>
          <div class="basic-item">
            <label class="item-label">进出厂时间：</label>
            <el-date-picker
              v-model="addCarTimesInfoParams.inOutTime"
              type="datetime"
            ></el-date-picker>
          </div>
          <div class="basic-item">
            <label class="item-label">车牌颜色：</label>
            <el-select
              class="secondLevel-select"
              v-model="addCarTimesInfoParams.vehicleColorIndex"
              placeholder="请选择"
            >
              <el-option label="蓝牌" :value="1"></el-option>
              <el-option label="黄牌" :value="2"></el-option>
              <el-option label="白牌" :value="3"></el-option>
              <el-option label="黑牌" :value="4"></el-option>
              <el-option label="绿牌" :value="5"></el-option>
              <el-option label="黄绿牌" :value="6"></el-option>
              <el-option label="未知" :value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="picture-info">
          <div
            class="picture-inner"
            @click="picture_click(carDefaultInfo.drivingLicenseImage)"
          >
            <div class="picture">
              <img
                v-if="carDefaultInfo.drivingLicenseImage"
                :src="carDefaultInfo && carDefaultInfo.drivingLicenseImage"
              />
              <img v-else src="./img/no_img.png" />
              <span>行驶证</span>
            </div>
          </div>
          <div
            class="picture-inner"
            @click="picture_click(carDefaultInfo.onBoardList)"
          >
            <div class="picture">
              <img
                v-if="carDefaultInfo.onBoardList"
                :src="carDefaultInfo && carDefaultInfo.onBoardList"
              />
              <img v-else src="./img/no_img.png" />
              <span>随车清单</span>
            </div>
          </div>
        </div>
        <!-- <div class="account-title">添加车次信息</div> -->

        <div class="picture-info">
          <div class="picture-inner">
            <div class="picture">
              <img
                v-if="addCarTimesInfoParams.inOutImage"
                :src="addCarTimesInfoParams && addCarTimesInfoParams.inOutImage"
                @click="picture_click(addCarTimesInfoParams.inOutImage)"
              />
              <img v-else src="./img/no_img.png" />
              <div class="upload">
                <!-- :http-request="submitUpload" -->
                <el-upload
                  class="upload-demo"
                  accept=".jpg, .jpeg, .png"
                  :on-change="handleChange"
                  :file-list="fileList"
                  :show-file-list="false"
                  :on-success="unloadDPSuccess"
                  :on-error="uploadError"
                  :limit="1"
                  :action="cleanTransportIp + uploadImgUrl + '?imageType=0'"
                >
                  <el-button size="small" type="primary">+上传图片</el-button>
                </el-upload>
              </div>
              <span>进出厂照片</span>
            </div>
          </div>
          <div class="picture-inner">
            <div class="picture">
              <img
                v-if="addCarTimesInfoParams.inOutPlateImage"
                @click="picture_click(addCarTimesInfoParams.inOutPlateImage)"
                :src="
                  addCarTimesInfoParams && addCarTimesInfoParams.inOutPlateImage
                "
              />
              <img v-else src="./img/no_img.png" />
              <div class="upload">
                <!-- :http-request="submitUpload1" -->
                <el-upload
                  class="upload-demo"
                  accept=".jpg, .jpeg, .png"
                  :on-success="uploadlLPSuccess"
                  :on-error="uploadError"
                  :on-change="handleChange"
                  :file-list="fileList"
                  :show-file-list="false"
                  :limit="1"
                  :action="cleanTransportIp + uploadImgUrl + '?imageType=3'"
                >
                  <el-button size="small" type="primary">+上传图片</el-button>
                </el-upload>
              </div>
              <span>进出厂牌照照片</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <a class="self_btn" @click="returnClick(2)">关闭</a>
        <a class="self_btn" @click="saveCarTimesInfoParams">保存</a>
      </div>
    </div>

    <addCarBaseInfo
      :globalInstance="globalInstance"
      ref="acbiRef"
    ></addCarBaseInfo>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import imgBox from "./components/imgBox.vue";
import { dateFormat, deteleObject } from "@/utils/tools.js";
import addCarBaseInfo from "./components/addCarBaseInfo.vue";
import { DatePicker } from "@/modules/commonDatePicker";
export default {
  name: "listOverview",
  title: "详细信息",
  props: ["globalInstance"],
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  components: {
    addCarBaseInfo,
    DatePicker,
  },
  data() {
    return {
      electricVehicle: bmeConfig.electricVehicle,
      pageInfo: "listOverview.vue",
      computedName: "运输车辆清单总览组件",
      newAccessType: this.$store.state.newAccessType,
      styleType: "",
      isPublicCleanTransport: bmeConfig.isPublicCleanTransport,
      vehicleMissionsName: {
        0: "未知",
        1: "国Ⅰ",
        3: "国III",
        4: "国IV",
        5: "国V",
        6: "国VI",
        99: "新能源",
        // 101: "铁路运输",
        // 102: "水路运输",
        // 103: "管道或管状带式输送机",
      },
      params: {
        startTime: "", // 起始时间
        endTime: "", // 结束时间
        numberPlate: "", // 车牌号
        vehicleUseType: "", // 车辆使用类型
        fuelType: "", // 燃料类型
        vehicleEmission: "", // 排放类型
        plateColor: "", // 车牌颜色
        inGatePostCode: "", // 进场门岗编号
        transportCode: "", // 称重单号
        transportType: "", // 货物种类
        transportName: "", // 货物名称
        outGatePostCode: "", // 出场门岗编号
        vin: "", // VIN
        engineNumber: "", // 发动机型号
        // registrationDate: "", // 注册时间
        registStartTime: "",
        registEndTime: "",
        pageNo: 1,
        pageSize: 50,
        onlineStatus: "", // 联网状态
      },
      timeArr: null,
      page_total: 0,
      dataList: [],
      info: "",
      customerId: this.$store.state.customerId,
      curTab: "carTimes",
      lableAll: [
        {
          key: "numberPlate",
          label: "车牌号",
        },
        {
          key: "vehicleUseType",
          label: "车辆使用类型",
        },
        {
          key: "fuelType",
          label: "燃料类型",
        },
        {
          key: "vehicleEmissions",
          label: "排放阶段",
        },
        {
          key: "plateColor",
          label: "车牌颜色",
        },
        {
          key: "inTime",
          label: "进厂时间",
        },
        {
          key: "inGatePostName",
          label: "进厂门岗",
        },
        {
          key: "inTransportCode",
          label: "进厂称重单号",
        },
        {
          key: "inTransportType",
          label: "进厂货物种类",
        },
        {
          key: "inTransportName",
          label: "进厂货物名称",
        },
        {
          key: "inTransportVolume",
          label: "进厂运输量(t)",
        },
        {
          key: "inMeasureTime",
          label: "进厂计量时间",
        },
        {
          key: "outTime",
          label: "出厂时间",
        },
        {
          key: "outGatePostCode",
          label: "出厂门岗",
        },
        {
          key: "outTransportCode",
          label: "出厂称重单号",
        },
        {
          key: "outTransportType",
          label: "出厂货物种类",
        },
        {
          key: "outTransportName",
          label: "出厂货物名称",
        },
        {
          key: "outTransportVolume",
          label: "出厂运输量(t)",
        },
        {
          key: "outMeasureTime",
          label: "出厂计量时间",
        },
        // {
        //   key: 'shipper',
        //   label: '发货单位'
        // }, {
        //   key: 'consignee',
        //   label: '收货单位'
        // }, {
        //   key: 'loadDischargeAddress',
        //   label: '装卸货地点'
        // }, {
        //   key: 'recordMode',
        //   label: '记录形式'
        // },
        {
          key: "vin",
          label: "VIN",
        },
        {
          key: "onlineStatus",
          label: "联网状态",
        },
        {
          key: "engineNumber",
          label: "发动机号码",
        },
        {
          key: "registrationDate",
          label: "注册日期",
        },
      ],
      lableAll1: [
        {
          key: "numberPlate",
          label: "车牌号",
        },
        {
          key: "vehicleEmissions",
          label: "排放阶段",
        },
        {
          key: "vehicleColor",
          label: "车牌颜色",
        },
      ],
      detailShow: "",
      params1: {
        startTime: "",
        endTime: "",
        numberPlate: "",
        vehicleEmission: "",
        vehicleColor: "",
        inorOut: 1,
      },
      pageNo1: 1,
      pageSize1: 50,
      pageNo2: 1,
      pageSize2: 50,
      timeArr1: "",
      timeArr2: [],
      dataList1: "",
      page_total1: "",
      dataList2: "",
      page_total2: "",
      carDetail: "",
      carinfo: "",

      vehicleUseTypeArr: [], // 车辆类型下拉
      fuelTypeListArr: [], // 燃料类型下拉
      plateColorListArr: [], // 车牌颜色下拉
      postCodeListArr: [], // 门禁下拉
      emissionTypeListArr: [], // 排放阶段下拉
      netstatusListArr: [
        {label: '未联网', value: '0'},
        {label: '已联网', value: '1'},
        {label: '未知', value: '2'},
      ],
      statisticsInfo: "", // 总数统计

      numberPlate: "", // 车牌号查询
      carDefaultInfo: "",
      addCarTimesInfoParams: {
        // vehicleColor: '', //
        inOutTime: "", // 进出场时间
        inOutImage: "", // 进出场照片
        inOutPlateImage: "", // 进出场牌照照片
        inOrOut: "", // 进出场
        vehicleColorIndex: "", // 车牌颜色
        numberPlate: "", // 车牌号
      },
      imgUploadUrl: "",
      fileList: [],
      imageType: "",
      editStatus: false,
      inAndOutDetails: {},
      uploadImgUrl: "/transport/upload/image",
      addThreeItem:false,
  };
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
    }),
    ...mapState({ cleanTransportIp: "cleanTransportIp" }),
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType;
    },
    showCleanTransportSetVal() {
      return this.$store.state.showCleanTransportSet;
    },
    realWidth() {
      let width = ''
      if(bmeConfig.ismiddleClean) {
        width = bmeConfig.INIT_WIDTH - 100 + "px"
      } else {
        width = "3740px"
      }
      return width
    },
    realHeight() {
      let width = ''
      if(bmeConfig.ismiddleClean) {
        width = "400px"
      } else {
        width = "540px"
      }
      return width
    }
  },
  created() {
    console.log("globalInstance", this.globalInstance);
    this.styleType = this.globalInstance.$store.state.styleType;
    if (this.isPublicCleanTransport) {
      this.lableAll = this.lableAll.map((i) => {
        // if (i.label == '燃料类型') {
        //   i.label = '车辆使用类型'
        //   i.key = 'vehicleUseType'
        // }
        if (i.label == "车辆类型") {
          i.label = "车辆使用类型";
          i.key = "vehicleUseType";
        }
        if (i.label == "进厂门岗") {
          if (this.customerId == 19) {
            i.key = "inGatePostName";
          }
        }
        if (i.label == "出厂门岗") {
          i.key = "outGatePostName";
        }
        return i;
      });
      if (this.customerId == 136) {
        this.lableAll = this.lableAll.concat([
          {
            label: "车辆品牌",
            key: "model",
          },
          {
            label: "是否联网",
            key: "onlineStatus",
          },
          {
            label: "企业编码",
            key: "companyNo",
          },
        ]);
      } else if (this.customerId == 118 || this.customerId == 135) {
        this.lableAll = [
          {
            key: "numberPlate",
            label: "车牌号",
          },
          {
            key: "vehicleUseType",
            label: "车辆使用类型",
          },
          {
            key: "fuelType",
            label: "燃料类型",
          },
          {
            key: "vehicleEmissions",
            label: "排放阶段",
          },
          {
            key: "plateColor",
            label: "车牌颜色",
          },
          {
            key: "inTime",
            label: "进厂时间",
          },
          {
            key: "inGatePostName",
            label: "进厂门岗",
          },
          {
            key: "inOutNumber",
            label: "出入口编号",
          },
          {
            key: "gateNumber",
            label: "道闸编号",
          },
          {
            key: "natureUse",
            label: "使用性质",
          },
          {
            key: "inTransportCode",
            label: "进厂称重单号",
          },
          {
            key: "inTransportType",
            label: "进厂货物种类",
          },
          {
            key: "inTransportName",
            label: "进厂货物名称",
          },
          {
            key: "inTransportVolume",
            label: "进厂运输量(t)",
          },
          {
            key: "inMeasureTime",
            label: "进厂计量时间",
          },
          {
            key: "outTime",
            label: "出厂时间",
          },
          {
            key: "outGatePostCode",
            label: "出厂门岗",
          },
          {
            key: "outTransportCode",
            label: "出厂称重单号",
          },
          {
            key: "outTransportType",
            label: "出厂货物种类",
          },
          {
            key: "outTransportName",
            label: "出厂货物名称",
          },
          {
            key: "outTransportVolume",
            label: "出厂运输量(t)",
          },
          {
            key: "outMeasureTime",
            label: "出厂计量时间",
          },
          {
            key: "vin",
            label: "VIN",
          },
          {
            key: "onlineStatus",
            label: "联网状态",
          },
          {
            key: "engineNumber",
            label: "发动机号码",
          },
          {
            key: "registrationDate",
            label: "注册日期",
          },
        ];
      }
      if (this.customerId == 50) {
        this.lableAll = this.lableAll.map((i) => {
          if (i.label === "进厂计量时间") {
            i.label = "计量时间";
          }
          return i;
        });
      }
    } else {
      if (this.customerId == 89) {
        this.lableAll = this.lableAll.map((i) => {
          if (i.label === "车辆类型") {
            i.label = "车辆使用类型";
          }
          return i;
        });
      }
    }
    this.timeArr = [
      dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        new Date(new Date() - 24 * 60 * 60 * 1000)
      ),
      dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
    ];
    if (this.customerId == 19) {
      this.timeArr = [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date().setHours(0, 0, 0, 0))
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
    }
    this.timeArr1 = [
      dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        new Date(new Date() - 24 * 60 * 60 * 1000)
      ),
      dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
    ];
    const threeFactory = [129,122,148,135,156,146,126]
    this.addThreeItem = threeFactory.indexOf(this.customerId) > -1? true:false
  },

  mounted() {
    this.vehicleUseType();
    this.fuelTypeList();
    // this.plateColorList()
    this.gatePostCodeList();
    this.emissionTypeList();
    this.getStatistics();
    this.getCarCountInfo(1);
    this.getCarCountInfo(2);
    this.getTransportList();
    this.params.vehicleEmission = "";
    if (this.electricVehicle) {
      this.vehicleMissionsName["199"] = "纯电";
    }
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  methods: {
    changeTime(time) {
      this.timeArr = time;
    },
    changeTime1(time) {
      this.timeArr2 = time;
    },
    getNewTime(time) {
      this.timeArr1 = time;
    },
    addNewCarInfo(num) {
      this.$refs.acbiRef.getNum(num);
    },
    // 查询车辆基础信息
    async getCarDefaultInfo() {
      let url = this.cleanTransportIp + "/transport/info";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        numberPlate: this.numberPlate,
      });
      // let res =  {
      //   "gatePostCode": "HL-N01",
      //   "vin": "LFWSRX9L3LAC21201",
      //   "model": "解放牌CA4250P2K8T1NE6A",
      //   "issueDate": "20200709",
      //   "natureUse": "货运",
      //   "engineNumber": "3120D036634",
      //   "numberPlate": "冀A209VP",
      //   "owner": "河北大通汽车贸易有限公司",
      //   "address": "河北省石家庄市裕华区建设南大街与塔南路交叉口S0H0前程大厦1910室",
      //   "registrationDate": "20200709",
      //   "vehicleType": "重型燃气车-重型半挂牵引车",
      //   "vehicleEmissions": 6,
      //   "drivingLicenseImage": "http://172.168.1.101:8181/220302/Driving_License/8_15_9_175.jpg",
      //   "onBoardList": "http://172.168.1.101:8181/220825/Vehicle_Board_list/LFWSRX9L3LAC21201.jpg",
      //   "createTime": null,
      //   "registrationTime": null
      // }
      if (res) {
        this.carDefaultInfo = res || [];
      } else {
        this.carDefaultInfo = "";
      }
    },

    // 上传进出场照片
    async submitUpload(content) {
      console.log("content", content);
      const formData = new FormData();
      formData.append("file", content.file);
      // formData.append('imageType', 5)  // 1-驾照 2-随车清单 3-车牌 0-其他
      console.log("formData", formData.get("file"));
      let url =
        this.cleanTransportIp + "/transport/upload/image" + "?imageType=0";
      let res = await this.globalInstance.$apiUtils.post3(url, formData);
      if (res) {
        this.addCarTimesInfoParams.inOutPlateImage = res.httpUrl;
        this.$message({
          type: "success",
          message: "上传成功!",
        });
      } else {
        this.$message({
          type: "error",
          message: "上传失败!",
        });
      }
    },

    // 上传进出场牌照照片
    async submitUpload1(content) {
      const formData = new FormData();
      formData.append("file", content.file);
      // formData.append('imageType', 5)  // 1-驾照 2-随车清单 3-车牌 0-其他

      let url =
        this.cleanTransportIp + "/transport/upload/image" + "?imageType=3";
      let res = await this.globalInstance.$apiUtils.post3(url, formData);
      if (res) {
        this.addCarTimesInfoParams.inOutImage = res.httpUrl;
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
    },

    uploadlLPSuccess(response, file, fileList) {
      this.addCarTimesInfoParams.inOutPlateImage = response.data.httpUrl;
      this.$message.success("上传成功！");
    },

    unloadDPSuccess(response, file, fileList) {
      this.addCarTimesInfoParams.inOutImage = response.data.httpUrl;
      this.$message.success("上传成功！");
    },

    uploadError(err) {
      console.log(err);
      this.$message.error("上传失败！");
    },

    async saveCarTimesInfoParams() {
      if (!this.carDefaultInfo && !this.editStatus) {
        this.$message.warning(
          "未查到车辆基本信息，请先查询或则先添加车辆信息！"
        );
        return;
      }
      if (this.addCarTimesInfoParams.inOutTime) {
        this.addCarTimesInfoParams.inOutTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.addCarTimesInfoParams.inOutTime
        );
      }
      this.addCarTimesInfoParams.numberPlate =
        this.addCarTimesInfoParams.numberPlate;
      this.addCarTimesInfoParams.gatePostCode =
        this.carDefaultInfo.gatePostCode;
      console.log("addCarTimesInfoParams", this.addCarTimesInfoParams);
      let res = "";
      if (this.editStatus) {
        let url = this.cleanTransportIp + "/vehicle/transport/update/transport";
        res = await this.globalInstance.$apiUtils.put(
          url,
          this.addCarTimesInfoParams
        );
      } else {
        let url = this.cleanTransportIp + "/vehicle/transport/add/transport";
        res = await this.globalInstance.$apiUtils.post(
          url,
          this.addCarTimesInfoParams
        );
      }

      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": {
      //     "inTotal": 205,
      //     "inTransportTotal": 74.0,
      //     "outTotal": 172,
      //     "outTransportTotal": 0.0
      //   }
      // }
      if (res) {
        this.$message.success("添加成功！");
        this.returnClick(2);
      }
    },

    handleChange(file, fileList) {
      console.log("1231", file.url);
      // this.ruleForm.checkDustImgList.push(file.url) = fileList.slice(-3)
    },

    // 新增车辆信息
    addCarInfo() {
      this.editStatus = false;
      this.detailShow = 3;
      this.numberPlate = "";
      this.inAndOutDetails = "";
      this.addCarTimesInfoParams = {
        inOutTime: "", // 进出场时间
        inOutImage: "", // 进出场照片
        inOutPlateImage: "", // 进出场牌照照片
        inOrOut: "", // 进出场
        vehicleColorIndex: "", // 车牌颜色
        numberPlate: "",
      };
      this.carDefaultInfo = "";
    },

    // 编辑
    editInfo(row) {
      console.log("row", row);
      this.editStatus = true;
      this.detailShow = 3;
      this.numberPlate = row.numberPlate;
      this.getCarDefaultInfo();
      this.getInAndOutDetails(row.id);
    },

    changeInOrOut(value) {
      if (this.editStatus) {
        if (value === 1) {
          this.addCarTimesInfoParams.inOutTime =
            this.inAndOutDetails.inInfo.inOutTime;
          this.addCarTimesInfoParams.inOutImage =
            this.inAndOutDetails.inInfo.inOutImage;
          this.addCarTimesInfoParams.inOutPlateImage =
            this.inAndOutDetails.inInfo.inOutPlateImage;
          this.addCarTimesInfoParams.inOrOut =
            this.inAndOutDetails.inInfo.inOrOut;
          this.addCarTimesInfoParams.numberPlate =
            this.inAndOutDetails.inInfo.numberPlate;
          this.addCarTimesInfoParams.vehicleColorIndex = Number(
            this.inAndOutDetails.inInfo.vehicleColorIndex
          );
        } else {
          this.addCarTimesInfoParams.inOutTime =
            this.inAndOutDetails.outInfo.inOutTime;
          this.addCarTimesInfoParams.inOutImage =
            this.inAndOutDetails.outInfo.inOutImage;
          this.addCarTimesInfoParams.inOutPlateImage =
            this.inAndOutDetails.outInfo.inOutPlateImage;
          this.addCarTimesInfoParams.inOrOut =
            this.inAndOutDetails.outInfo.inOrOut;
          this.addCarTimesInfoParams.numberPlate =
            this.inAndOutDetails.outInfo.numberPlate;
          this.addCarTimesInfoParams.vehicleColorIndex = Number(
            this.inAndOutDetails.outInfo.vehicleColorIndex
          );
        }
      }
    },

    // 编辑时请求详情
    async getInAndOutDetails(id) {
      let url = this.cleanTransportIp + "/vehicle/transport/inAndOut/details";
      let res = await this.globalInstance.$apiUtils.get3(url, { id });
      // let res =  {
      //   "inInfo": {
      //       "id": 2,
      //       "numberPlate": "津B16C80",
      //       "inOutTime": "2022-01-10T01:07:13.087+00:00",
      //       "inOutImage": "http://172.168.1.101:8181/220110/Vehicle_Plate/9_7_12_878.jpg",
      //       "inOrOut": 1,
      //       "gatePostCode": "BME_HLS01",
      //       "inOutPlateImage": "http://172.168.1.101:8181/220110/ALL_Vehicle_SmallPlate/9_7_13_40.jpg",
      //       "vehicleColorIndex": "1"
      //   },
      //   "outInfo": {
      //       "id": 1641,
      //       "numberPlate": "津B16C81",
      //       "inOutTime": "2022-01-25T03:14:46.767+00:00",
      //       "inOutImage": "http://172.168.1.101:8181/220125/Vehicle_Plate/11_14_46_549.jpg",
      //       "inOrOut": 2,
      //       "gatePostCode": "HL-38",
      //       "inOutPlateImage": "http://172.168.1.101:8181/220125/ALL_Vehicle_SmallPlate/11_14_46_752.jpg",
      //       "vehicleColorIndex": "1"
      //   }
      // }

      if (res) {
        this.inAndOutDetails = res || {};
        this.addCarTimesInfoParams.inOutTime = res.inInfo.inOutTime;
        this.addCarTimesInfoParams.numberPlate = res.inInfo.numberPlate;
        this.addCarTimesInfoParams.inOutImage = res.inInfo.inOutImage;
        this.addCarTimesInfoParams.inOutPlateImage = res.inInfo.inOutPlateImage;
        this.addCarTimesInfoParams.inOrOut = res.inInfo.inOrOut;
        this.addCarTimesInfoParams.id = id;
        this.addCarTimesInfoParams.vehicleColorIndex = Number(
          res.inInfo.vehicleColorIndex
        );
      }
    },
    // 车辆类型下拉
    async vehicleUseType() {
      let url, res;
      if (this.isPublicCleanTransport || this.customerId == 89) {
        // 南通中天部署的私有云，但是部分接口走的公有云接口
        url = this.cleanTransportIp + "/vehicle/transport/vehicleUseTypeList";
        res = await this.globalInstance.$apiUtils.get3(url, {
          customerId: this.customerId,
        });
      } else {
        url = this.cleanTransportIp + "/vehicle/transport/vehicleUseType";
        res = await this.globalInstance.$apiUtils.get(url, {
          customerId: this.customerId,
        });
      }
      if (res) {
        this.vehicleUseTypeArr = res || [];
      }
      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": ['选项1', '选项2']
      // }
    },

    // 燃料类型下拉
    async fuelTypeList() {
      let url = this.cleanTransportIp + "/vehicle/transport/fuelTypeList";
      let res;
      if (this.isPublicCleanTransport) {
        res = await this.globalInstance.$apiUtils.get3(url, {
          customerId: this.customerId,
        });
      } else {
        res = await this.globalInstance.$apiUtils.get(url, {
          customerId: this.customerId,
        });
      }

      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": ['选项1', '选项2']
      // }
      if (res) this.fuelTypeListArr = res || [];
    },

    // 车牌颜色下拉
    async plateColorList() {
      let url = this.cleanTransportIp + "/vehicle/transport/plateColorList";
      let res;
      if (this.isPublicCleanTransport) {
        res = await this.globalInstance.$apiUtils.get3(url, {
          customerId: this.customerId,
        });
      } else {
        res = await this.globalInstance.$apiUtils.get(url, {
          customerId: this.customerId,
        });
      }
      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": ['选项1', '选项2']
      // }
      if (res) this.plateColorListArr = res || [];
    },

    // 门禁下拉
    async gatePostCodeList() {
      let url, res;
      if (this.isPublicCleanTransport) {
        url = this.cleanTransportIp + "/vehicle/transport/gatePostCodeListNew";
        res = await this.globalInstance.$apiUtils.get3(url, {
          customerId: this.customerId,
        });
      } else {
        url = this.cleanTransportIp + "/vehicle/transport/gatePostCodeList";
        res = await this.globalInstance.$apiUtils.get(url, {
          customerId: this.customerId,
        });
      }
      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": ['选项1', '选项2']
      // }
      if (res) this.postCodeListArr = res || [];
    },

    // 排放阶段下拉
    async emissionTypeList() {
      let url = this.cleanTransportIp + "/vehicle/transport/emissionTypeList";
      let res;
      if (this.isPublicCleanTransport) {
        res = await this.globalInstance.$apiUtils.get3(url, {
          customerId: this.customerId,
        });
      } else {
        res = await this.globalInstance.$apiUtils.get(url, {
          customerId: this.customerId,
        });
      }
      //   let res = {
      //     "success": true,
      //     "type": 0,
      //     "msg": null,
      //     "data": [
      //     {
      //         "name": "未知",
      //         "emissionCode": 0
      //     },
      //     {
      //         "name": "国Ⅲ",
      //         "emissionCode": 3
      //     },
      //     {
      //         "name": "国VI",
      //         "emissionCode": 6
      //     },
      //     {
      //         "name": "国IV",
      //         "emissionCode": 4
      //     },
      //     {
      //         "name": "国V",
      //         "emissionCode": 5
      //     },
      //     {
      //         "name": "新能源",
      //         "emissionCode": 99
      //     }
      // ]
      //   }
      if (res) this.emissionTypeListArr = res || [];
    },

    // 总数统计
    async getStatistics() {
      if (this.timeArr !== null) {
        this.params.startTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr[0]
        );
        this.params.endTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr[1]
        );
      } else {
        (this.params.startTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        )),
          (this.params.endTime = dateFormat("YYYY-mm-dd HH:MM:SS", new Date()));
      }
      this.params.registStartTime = dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        this.timeArr2[0]
      );
      this.params.registEndTime = dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        this.timeArr2[1]
      );
      this.params.customerId = this.customerId;
      // this.params.vehicleEmission = this.params.vehicleEmissions
      // this.params.vehicleEmissions = "";
      let url = this.cleanTransportIp + "/vehicle/transport/statistics/info";
      let res;
      if (this.isPublicCleanTransport) {
        res = await this.$apiUtils.post3(url, this.params);
      } else {
        res = await this.globalInstance.$apiUtils.post(url, this.params);
      }
      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": {
      //     "inTotal": 205,
      //     "inTransportTotal": 74.0,
      //     "outTotal": 172,
      //     "outTransportTotal": 0.0
      //   }
      // }
      if (res) this.statisticsInfo = res;
    },

    // 详情
    async getDetails(id, createTime) {
      let url = this.cleanTransportIp + "/vehicle/transport/details";
      let res;
      if (
        this.isPublicCleanTransport ||
        this.customerId == 89 ||
        this.customerId == 94 ||
        this.customerId == 54 ||
        this.customerId == 92 ||
        this.customerId == 58 ||
        bmeConfig.isnewVesionTansDetail
      ) {
        res = await this.globalInstance.$apiUtils.get3(url, {
          id,
          createTime,
          customerId: this.customerId,
        });
      } else {
        res = await this.globalInstance.$apiUtils.get(url, {
          id,
          customerId: this.customerId,
        });
      }
      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": {
      //   "id": 116955,
      //   "numberPlate": "鲁Q936DW",
      //   "vehicleUseType": null,
      //   "fuelType": null,
      //   "vehicleEmission": "6",
      //   "plateColor": null,
      //   "inTime": "2022-09-09T03:24:44.567+00:00",
      //   "inGatePostCode": "HL-W01",
      //   "inTransportCode": null,
      //   "inTransportType": null,
      //   "inTransportName": "--",
      //   "inTransportVolume": 0.0,
      //   "inMeasureTime": null,
      //   "outTime": null,
      //   "outGatePostCode": null,
      //   "outTransportCode": null,
      //   "outTransportType": null,
      //   "outTransportName": "--",
      //   "outTransportVolume": 0.0,
      //   "outMeasureTime": null,
      //   "shipper": null,
      //   "consignee": null,
      //   "loadDischargeAddress": null,
      //   "recordMode": null,
      //   "vin": "LZZ1CLWBXNJ232225",
      //   "registrationDate": "20220518",
      //   "engineNumber": "14211093522",
      //   "driverLicenseImageUrl": null,
      //   "onBoardListImageUrl": "http://172.168.1.101:8181/220805/Vehicle_Board_list/LZZ1CLWBXNJ232225.jpg",
      //   "nameplateImageUrl": null
      //   }
      // }
      if (res) {
        switch (res.vehicleUseType) {
          case "1":
            res.vehicleUseType = "大宗物料车辆";
            break;
          case "0":
            res.vehicleUseType = "未知";
            break;
          case "2":
            res.vehicleUseType = "非大宗物料车辆";
            break;
          default:
            if (this.customerId != 99) {
              res.vehicleUseType = "";
            }
            if (this.customerId == 45) {
              if (!res.vehicleUseType) {
                res.vehicleUseType = "非大宗物料车辆";
              }
            }
        }
        this.carinfo = res;
      } else {
        this.carinfo = {};
      }
    },

    // 列表分页
    async getTransportList() {
      if (this.timeArr !== null) {
        this.params.startTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr[0]
        );
        this.params.endTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr[1]
        );
      } else {
        this.params.startTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        );
        this.params.endTime = dateFormat("YYYY-mm-dd HH:MM:SS", new Date());
      }
      if (this.timeArr2 !== null) {
        this.params.registStartTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr2[0]
        );
        this.params.registEndTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr2[1]
        );
      }
      this.params.customerId = this.customerId;
      let url = this.cleanTransportIp + "/vehicle/transport/list";

      let res;
      if (this.isPublicCleanTransport) {
        res = await this.$apiUtils.post3(url, this.params);
      } else {
        res = await this.globalInstance.$apiUtils.post(url, this.params);
      }
      console.log("this.params", this.params);
      // let res = {
      //   offsetSize: 3,
      //   pageSize: 10,
      //   rowCount: 1,
      //   pageNo: 1,
      //   list: [
      //     {
      //       id: 116936,
      //       numberPlate: '苏GE8105',
      //       vehicleUseType: null,
      //       fuelType: null,
      //       vehicleEmission: '6',
      //       plateColor: null,
      //       inTime: '2022-09-09T02:55:42.853+00:00',
      //       inGatePostCode: 'HL-W01',
      //       inTransportCode: null,
      //       inTransportType: null,
      //       inTransportName: '大宗:镍矿',
      //       inTransportVolume: 53.96,
      //       inMeasureTime: '2022-09-09T03:06:17.000+00:00',
      //       outTime: '2022-09-09T03:08:23.837+00:00',
      //       outGatePostCode: 'HL-W01',
      //       outTransportCode: null,
      //       outTransportType: null,
      //       outTransportName: '--',
      //       outTransportVolume: 0.0,
      //       outMeasureTime: null,
      //       shipper: null,
      //       consignee: null,
      //       loadDischargeAddress: null,
      //       recordMode: null,
      //       vin: 'LZGJLGX46MX139858',
      //       registrationDate: '20220510',
      //       engineNumber: '3121J071185'
      //     }
      //   ],
      //   firstResult: 0,
      //   pageCount: 1
      // }
      if (res) {
        this.pageNo = res.pageNo;
        this.dataList = res.list;
        if (this.customerId == 45) {
          this.dataList.forEach((item) => {
            if (!item.vehicleUseType) {
              item.vehicleUseType = "非大宗物料车辆";
            }
          });
        }
        this.page_total = res.rowCount;
      }
    },

    seartchList() {
      this.params.pageNo = 1;
      this.getTransportList();
      this.getStatistics();
    },

    tabSwitch(val) {
      this.curTab = val;
    },
    async getCarCountInfo(inorOut) {
      // let url = this.globalInstance.cleanTransportIp + "/in_factory/list";
      if (this.timeArr1 !== null) {
        this.params1.startTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr1[0]
        );
        this.params1.endTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.timeArr1[1]
        );
      } else {
        (this.params1.startTime = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        )),
          (this.params1.endTime = dateFormat(
            "YYYY-mm-dd HH:MM:SS",
            new Date()
          ));
      }

      this.params1.inorOut = inorOut;

      if (inorOut === 1) {
        this.params1.pageNo = this.pageNo1;
        this.params1.pageSize = this.pageSize1;
      } else if (inorOut === 2) {
        this.params1.pageNo = this.pageNo2;
        this.params1.pageSize = this.pageSize2;
      }

      let url = this.cleanTransportIp + "/transport/getCarCountInfo";
      let res;
      if (this.isPublicCleanTransport) {
        this.params1.customerId = this.customerId;
        res = await this.globalInstance.$apiUtils.get3(url, this.params1);
      } else {
        if (this.customerId == 94) {
          this.params1.vehicleEmissions = this.params.vehicleEmission;
          delete this.params1.vehicleEmission;
        }
        // if (this.customerId == 81) {
        //   this.params1.customerId = this.customerId;
        // }
        this.params1.customerId = this.customerId;
        res = await this.globalInstance.$apiUtils.get(url, this.params1);
      }
      // let res = {
      //   "offsetSize": 3,
      //   "pageSize": 10,
      //   "rowCount": 1,
      //   "pageNo": 1,
      //   "list": [
      //       {
      //           "numberPlate": "冀D7D731",
      //           "vehicleEmissions": "国VI",
      //           "vehicleColor": "未知"
      //       }
      //   ],
      //   "firstResult": 0,
      //   "pageCount": 1
      // };
      if (res) {
        if (inorOut === 1) {
          this.dataList1 = res.list;
          this.page_total1 = res.rowCount;
        } else if (inorOut === 2) {
          this.dataList2 = res.list;
          this.page_total2 = res.rowCount;
        }
      }
    },
    async getCarDetail(numberPlate, color) {
      console.log("numberPlate", numberPlate, color);
      this.detailShow = 1;
      let url = this.cleanTransportIp + "/transport/getCarDetail";
      let res;
      if (this.isPublicCleanTransport) {
        res = await this.$apiUtils.get3(url, {
          numberPlate,
          customerId: this.customerId,
        });
      } else {
        res = await this.globalInstance.$apiUtils.get(url, {
          numberPlate,
          customerId: this.customerId,
        });
      }

      // let res = {
      //   "success": true,
      //   "type": 0,
      //   "msg": null,
      //   "data": {
      //       "numberPlate": "冀D7D731",
      //       "vehicleType": "重型柴油车-重型半挂牵引车",
      //       "vehicleTypeName": null,
      //       "fuelType": "柴油",
      //       "vehicleEmissions": 6,
      //       "vehicleEmissionsName": "国VI",
      //       "vehicleColor": "黄牌",
      //       "registrationDate": "20211229",
      //       "engineNumber": "1421K082012",
      //       "drivingLicenseImage": "http://172.168.1.101:8181/220330/Driving_License/12_54_24_292.jpg",
      //       "onBoardList": "http://172.168.1.101:8181/220805/Vehicle_Board_list/LZGJLGX48MX138730.jpg",
      //       "carMingList": null,
      //       "vin": "LZGJLGX48MX138730",
      //       "vehicleColorIndex": 2
      //   }
      // }
      if (res) {
        this.info = res;
        if (color) {
          this.info.vehicleColor = color;
        }
      } else {
        this.info = "";
      }
    },
    handleCurrentChange0(val) {
      this.params.pageNo = val;
      this.getTransportList();
    },
    handleCurrentChange() {
      this.pageNo1 = 1;
      this.pageSize = 50;
      this.pageNo2 = 1;
      this.pageSize2 = 50;
      this.getCarCountInfo(1);
      this.getCarCountInfo(2);
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.getCarCountInfo(1);
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.getCarCountInfo(2);
    },
    reset1() {
      this.pageNo1 = 1;
      this.pageSize = 50;
      this.pageNo2 = 1;
      this.pageSize2 = 50;
      this.params1 = {
        startTime: dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
        numberPlate: "",
        vehicleEmission: "",
        vehicleColor: "",
        inorOut: 1,
      };
      this.timeArr1 = [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.getCarCountInfo(1);
      this.getCarCountInfo(2);
    },

    reset() {
      this.timeArr = [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.timeArr2 = [];
      this.params = {
        startTime: dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
        numberPlate: "", // 车牌号
        vehicleUseType: "", // 车辆使用类型
        fuelType: "", // 燃料类型
        vehicleEmission: "", // 排放类型
        plateColor: "", // 车牌颜色
        inGatePostCode: "", // 进场门岗编号
        transportCode: "", // 称重单号
        transportType: "", // 货物种类
        transportName: "", // 货物名称
        outGatePostCode: "", // 出场门岗编号
        vin: "", // VIN
        engineNumber: "", // 发动机型号
        registStartTime: "",
        registEndTime: "",

        pageNo: 1,
        pageSize: 50,
        onlineStatus: '',
      };
      this.getTransportList();
      this.getStatistics();
    },
    rowClick0(row) {
      this.detailShow = 2;
      console.log(row);
      this.getDetails(row.id, row.createTime, row.vehicleColor);
    },
    rowClick(row) {
      this.detailShow = 1;
      this.getCarDetail(row.numberPlate, row.vehicleColor);
    },
    async getCarDetailInFactory(number) {
      let url =
        this.globalInstance.cleanTransportIp + "/vehicle/in_factory/detail";
      let res = await this.globalInstance.$apiUtils.get(url, {
        numberPlate: number,
        customerId: this.customerId,
      });
      // let res = {
      //   createTime: null,
      //   drivingLicense:
      //     "http://ulev.fj-sanbao.com/prod-api/profile/upload/2021/10/08/闽E89517行驶证.png/1af3b5c3385c9b5f911db1a86e89750c.png",
      //   engineNumber: "20A00366566",
      //   numberPlate: "1#重型半挂牵引车",
      //   onBoardList:
      //     "http://ulev.fj-sanbao.com/prod-api/profile/upload/2021/10/08/闽E89517机动车环保信息随车清单.png/16b081df3ee004fe67b6b5e67cff7657.png",
      //   registrationDate: "20210527",
      //   vehicleEmissions: 5,
      //   vin: "LZFH25W43LD048493",
      // };
      if (res) {
        this.info = res;
      }
    },
    returnClick(value) {
      this.detailShow = "";
    },
    close() {
      let that = this._.appContext.app;
      if (this.detailShow == 1) {
        this.info = "";
      }
      this.$popup.close(that);
    },
    picture_click(url) {
      if (!url) return;
      this.globalInstance.$store.commit("dialogStatus2", true);
      this.globalInstance.$popup.open2(imgBox, this.dialogCompontent2, this, {
        imgurl: url,
      });
    },

    exportExcel() {
      // this.showTips = true
      let that = this;

      // setTimeout(function () {
      //   that.showTips = false
      // }, 5000)
      this.$message.info("正在导出数据……");
      let ip = this.globalInstance.cleanTransportIp;
      let str = `${ip}/vehicle/transport/export?startTime=${dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        this.timeArr[0]
      )}&endTime=${dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        this.timeArr[1]
      )}&numberPlate=${this.params.numberPlate}&vehicleUseType=${
        this.params.vehicleUseType
      }&fuelType=${this.params.fuelType}&vehicleEmission=${
        this.params.vehicleEmission
      }&plateColor=${this.params.plateColor}&inGatePostCode=${
        this.params.inGatePostCode
      }&transportCode=${this.params.transportCode}&transportType=${
        this.params.transportType
      }&transportName=${this.params.transportName}&outGatePostCode=${
        this.params.outGatePostCode
      }&vin=${this.params.vin}&engineNumber=${
        this.params.engineNumber
      }&registStartTime=${
        this.timeArr2[0]
          ? dateFormat("YYYY-mm-dd HH:MM:SS", this.timeArr2[0])
          : ""
      }&registEndTime=${
        this.timeArr2[1]
          ? dateFormat("YYYY-mm-dd HH:MM:SS", this.timeArr2[1])
          : ""
      }&customerId=${this.customerId}`;
      let a = document.createElement("a");
      console.log(str, "str");
      a.setAttribute("href", str);
      a.setAttribute("id", "startTelMedicine");
      // a.target="_blank"
      document.body.appendChild(a);
      a.click();
      let elem = document.getElementById("startTelMedicine");
      elem.parentNode.removeChild(elem);
    },

    exportExcel1() {
      // this.showTips = true
      let that = this;

      // setTimeout(function () {
      //   that.showTips = false
      // }, 5000)
      this.$message.info("正在导出数据……");
      let ip = this.globalInstance.cleanTransportIp;
      let str = `${ip}/transport/exportCarDetail?startTime=${dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        this.timeArr1[0]
      )}&endTime=${dateFormat(
        "YYYY-mm-dd HH:MM:SS",
        this.timeArr1[1]
      )}&inorOut=1&numberPlate=${this.params1.numberPlate}&vehicleColor=${
        this.params1.vehicleColor
      }&vehicleEmissions=${this.params1.vehicleEmission}&customerId=${
        this.customerId
      }`;
      let a = document.createElement("a");
      a.setAttribute("href", str);
      a.setAttribute("id", "startTelMedicine");
      // a.target="_blank"
      document.body.appendChild(a);
      a.click();
      let elem = document.getElementById("startTelMedicine");
      elem.parentNode.removeChild(elem);
    },

    exportData() {
      let url = Api.export.exportPointData;
      this.$message.info("正在导出数据……");
      downloadFile(url, {
        customerId: this.customerId,
        ...this.pointParams,
      }).then((res) => {
        const BLOB = res; // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
        fileReader.readAsDataURL(BLOB); // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement("a");
          a.download = `点位清单详情——${
            this.pointParams.process ? this.pointParams.process : "全部"
          }.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          this.$message.success("数据导出成功!");
        };
      });
    },
  },
};
</script>
<style lang="scss">
.add_cartransform_info {
  padding-bottom: 80px !important;
  .el-form-item .el-form-item__label {
    width: 160px;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
  }
  .account {
  }
}

._boxBg_green_secondLevel.list_overview .el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  background: rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0px 1px 1px 0px #05fffa !important;
  border-radius: 6px !important;
}
.basic-item {
  .secondLevel-input {
    width: 260px;
    input {
      background: rgba(0, 0, 0, 0.2) !important;
      box-shadow: 0px 1px 1px 0px #05fffa !important;
      border-radius: 6px !important;
      height: 40px;
      width: 260px;
      border-radius: 6px !important;
      border: 1px solid !important;
    }
    .el-input .el-input__inner {
      color: #f4c48f !important;
    }
  }
}

._boxBg_green_secondLevel.list_overview .basic-item .el-input .el-input__inner {
  color: #f4c48f !important;
  font-size: 21px;
  font-weight: bold;
  width: 260px;
  height: 40px;
}
// ._boxBg_green_secondLevel.list_overview .el-form-item__content .el-date-editor input {
//   background: rgba(0,0,0,0.2) !important;
//   box-shadow: 0px 1px 1px 0px #05FFFA !important;
//   border-radius: 6px !important;
//   height: 40px;
// }

._boxBg_green_secondLevel.list_overview .el-input .el-input__inner {
  color: rgb(101, 245, 242);
}

._boxBg_green_secondLevel.list_overview
  .el-form-item__content
  .el-date-editor
  input {
  color: rgb(101, 245, 242) !important;
  &::placeholder {
    color: rgb(101, 245, 242, 0.5) !important;
  }
}
 .table_box{
  width: 100%;
  overflow-x: auto;
}
._boxBg_green_secondLevel.list_overview .table_box .thClass > .cell {
  color: #05fffa;
}

._boxBg_green_secondLevel.list_overview .el-table__empty-block {
  width: 100% !important;
}

._boxBg_green_secondLevel.list_overview .el-pagination {
  font-size: 18px;
}

._boxBg_green_secondLevel.list_overview
  .page_box
  .el-pagination__editor
  .el-input__inner {
  font-size: 18px;
}
._boxBg_green_secondLevel.list_overview,
._boxBg_dark_secondLevel.list_overview,
._boxBg_blue_secondLevel.list_overview,
._boxBg_strong_secondLevel.list_overview {
  .page_box {
    margin-top: 20px;
    justify-content: space-between;
    .tips {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 25px;
      margin-bottom: 10px;
    }
  }
  .page-wrap {
    display: flex;
    // align-items: center;
  }
  .static-data {
    font-size: 30px;
    font-weight: 800;
    color: #05fffa;
    line-height: 42px;
    display: flex;
    align-items: center;
    span {
      margin-right: 50px;
    }
  }
}
</style>
<style lang="scss" scoped>
//   .list_overview {
//     ._boxBg_green_secondLevel .secondLevel-form-inline .secondLevel-input {
//       background: rgba(0,0,0,0.2) !important;
//       box-shadow: 0px 1px 1px 0px #05FFFA !important;
//       border-radius: 6px !important;
//       border: 1px solid !important;
//     }
// }

._boxBg_green_secondLevel .secondLevel-form-inline .secondLevel-input {
  background: rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0px 1px 1px 0px #05fffa !important;
  border-radius: 6px !important;
  border: 1px solid !important;
}
._boxBg_green_secondLevel .secondLevel-form-inline .secondLevel-select {
  background: rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0px 1px 1px 0px #05fffa !important;
  border-radius: 6px !important;
  border: 1px solid !important;
}
</style>
<style lang="scss" scoped>
.add_cartransform_info {
  .picture-info {
    margin-top: 60px !important;
  }
}
.list_overview {
  // width: calc(3840px - 100px);
  .list_overview_detail {
    background: #000000;
    box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
    border-radius: 2px;
    // border: 1px solid;
    position: absolute;
    left: 50%;
    top: 20px;
    transform: translateX(-50%);
    height: 900px;
    overflow: hidden;
    padding: 50px;
    padding-top: 100px;
    z-index: 23;
    .account {
      background: rgba(0, 59, 58, 0.7);
      border: 1px solid rgba(5, 255, 250, 0.99);
      .account-title {
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;
        background: url("./img/icon.png") no-repeat left center;
        padding-left: 35px;
        margin-bottom: 20px;
      }
    }
    .detail_title {
      width: 350px;
      height: 60px;
      font-size: 26px;
      font-weight: 500;
      color: #f5a623;
      line-height: 57px;
      border-bottom: solid 2px #f5a623;
      text-align: center;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .background-strong {
    background: rgba(3, 37, 126, 0.9);
  }
  .inout_detail_top {
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: space-between;
    background-color: #000;
    position: fixed;
    top: 0;
    .selfClose_btn {
      position: absolute;
      right: 78px;
    }
  }
  .detail_title {
    width: 350px;
    height: 60px;
    font-size: 26px;
    font-weight: 500;
    color: #f5a623;
    line-height: 57px;
    border-bottom: solid 2px #f5a623;
    text-align: center;
  }
}

._boxBg_green_secondLevel {
  background: url("./img//bg.png") no-repeat center center;
  // border: 1px solid #05FFFA;
  background-size: 100% 100%;
  box-shadow: none;
}

._carinfo_tab {
  display: flex;
  align-items: center;

  .tab_item {
    width: 200px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    cursor: pointer;
    color: #99f5ff;
    box-shadow: 0px 1px 1px 0px #05fffa;
    border-radius: 2px;
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(28, 247, 255, 1),
        rgba(28, 158, 255, 1),
        rgba(28, 247, 255, 1),
        rgba(28, 178, 255, 1)
      )
      1 1;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
  }

  .tab_active {
    background: linear-gradient(180deg, #05fdf8 0%, rgba(5, 253, 248, 0) 100%);
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
    color: #fff;
  }

  .tab_left {
    border-right: none;
  }
}

.boxTitle {
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  color: #f7b500;
  line-height: 33px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  margin: 20px 0;
}

.tab2 {
  display: flex;
  justify-content: center;
  flex-direction: column;

  .tabel_list {
    display: flex;
    justify-content: center;
    padding: 0 100px;

    .tab_left {
      margin-right: 130px;
    }

    .tab_right {
      margin-left: 130px;
    }

    .tab_title {
      font-size: 30px;
      font-weight: 800;
      color: #05fffa;
      line-height: 42px;
      margin: 30px 0;
    }
  }

  .check_box {
    display: flex;
    justify-content: center;
  }
}

.account {
  width: 100%;
  height: 100% !important;
  padding: 30px 50px;
  font-size: 20px;
  overflow-y: scroll;

  .basic-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 10px 0 40px 0;
    align-items: baseline;
    .basic-item {
      width: 33.3%;
      height: 60px;
      line-height: 60px;
      white-space: nowrap;
      // display: flex;
      // align-items: center;
      .item-label {
        font-size: 21px;
        font-weight: bold;
        color: #b8b8b8;
        line-height: 16px;
      }
      span {
        font-size: 21px;
        font-weight: bold;
        color: #f4c48f;
        line-height: 16px;
      }
    }
  }
  .basic-info-new {
    align-items: center;
  }
  .picture-info2 {
    margin-top: 40px;
  }
  .picture-info {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .picture-inner {
      width: 49%;
      margin-bottom: 25px;
      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }

      .picture {
        padding: 10px;
        width: 100%;
        height: 340px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // background-image: url("../img/img_bg.png");
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        .upload {
          // width: 100%;
          // height: 100%;
          // border: solid 1px #b8b8b8;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        img {
          width: 100%;
          height: 100%;
        }

        span {
          font-weight: bold;
          color: #d7d7d7;
          font-size: 24px;
          padding: 5px;
          margin-bottom: 8px;
        }

        &:before {
          content: "";
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          // background-image: url("./../img/enlarge.png");
        }
      }
    }
  }
}

.more-detail {
  .account {
    .basic-item {
      width: 33.3%;
      height: 80px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
      line-height: 1;
      // align-items: center;
      .item-label {
        font-size: 21px;
        font-weight: bold;
        color: #b8b8b8;
        width: 200px;
        display: inline-block;
        vertical-align: middle;
        line-height: 0;
      }

      .item-line {
        font-size: 21px;
        font-weight: bold;
        color: #f4c48f;
        display: inline-block;
        height: 80px;
        white-space: pre-wrap;
        word-wrap: break-word;
        width: 260px;
        line-height: 26px;
      }
    }
  }
}
.car-type-content {
  display: flex;
  align-items: inherit;
}
.car-type-value {
  display: inline-block;
  width: calc(100% - 120px);
  white-space: break-spaces;
  line-height: 28px !important;
}
</style>
<style lang="scss" scoped>
.page-wrap {
  ::v-deep .el-pagination {
    --el-pagination-font-size: 24px;
  }
  ::v-deep .el-icon-arrow-left {
    margin: 0 auto;
  }
  ::v-deep .el-icon-arrow-right {
    margin: 0 auto;
  }
}
</style>
